import Cabecera from './cabecera.jpg'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { useState } from 'react'
import Check from '@mui/icons-material/Check'


export default function App() {
  const back = "https://inscripcion.ar:8009/"

  const [rechazado, setRechazado] = useState(false)
  const [espera, setEspera] = useState(false)
  const formato1 = "sm:text-sm md:text-lg py-5 flex flex-col items-start"
  const formato2 = "mr-10 w-64 font-semibold"
  const formato3 = "capitalize border-b border-gray-500 hover:border-b-red-600 focus:border-b-red-600 outline-none focus:ring-0 transition-colors duration-200"
  const formatoCod = 'mr-10 w-40 font-semibold'
  const formato_mail = "border-b border-gray-500 hover:border-b-red-600 focus:border-b-red-600 outline-none focus:ring-0 transition-colors duration-200"

  const [habilitado, setHabilitado] = useState(true)
  const [qr, setQr] = useState('')

  const [tipo, setTipo] = useState('P')
  const [rubro, setRubro] = useState('Agropecuario / Productor Agropecuario')
  const [img, setImg] = useState(null)
  const [valido, setValido] = useState(false)
  const [codigo, setCodigo] = useState('')
  const [cual, setCual] = useState('')

  const rubros = [
    { cartel: 'Agropecuario / Productor Agropecuario' },
    { cartel: 'Agroindustria' },
    { cartel: 'Constructora' },
    { cartel: 'Desarrolladora' },
    { cartel: 'Industria Manufacturera' },
    { cartel: 'Comercio Minorista' },
    { cartel: 'Comercio Mayorista' },
    { cartel: 'Servicios Profesionales' },
    { cartel: 'Tecnología e Informática' },
    { cartel: 'Gastronomía y Hotelería' },
    { cartel: 'Transporte y Logística' },
    { cartel: 'Inmobiliaria' },
    { cartel: 'Salud' },
    { cartel: 'Educación y Capacitación' },
    { cartel: 'Servicios Financieros' },
    { cartel: 'Energía y Servicios Públicos' },
    { cartel: 'Automotriz' },
    { cartel: 'Comunicación y Marketing' },
    { cartel: 'Maquinaria Agrícola' },
    { cartel: 'Insumos y Proveedores Agropecuarios' },
    { cartel: 'Cooperativas y Asociaciones' },
    { cartel: 'Otros' },
  ]



  const initialValues = {
    apellido: '',
    nombre: '',
    email: '',
    empresa: '',
    cargo: '',
    documento: '',
    telefono: ''
  }

  const validate = ((values) => {
    const errors = {}
    if (!values.apellido)
      errors.apellido = 'Apellido requerido'
    if (!values.nombre)
      errors.nombre = 'Apellido requerido'
    if (!values.email)
      errors.email = 'Correo Electrónico requerido'
    else
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email))
        errors.email = 'Correo electrónico inválido'
    if (!values.empresa)
      errors.empresa = 'Empresa requerida'
    if (!values.cargo)
      errors.cargo = 'Cargo requerido'
    if (!values.documento)
      errors.documento = 'Documento requerido'
    else {
      if ((values.documento).length < 7)
        errors.documento = 'Faltan dígitos'
      if ((values.documento).length > 8)
        errors.documento = 'Sobran dígitos'
      if (! /^[0-9]+$/.test(values.documento))
        errors.documento = 'Solo dígitos'
    }
    if (!values.telefono)
      errors.telefono = 'Teléfono requerido'
    else
      if (! /^[0-9]+$/.test(values.telefono))
        errors.telefono = 'Solo dígitos'
    return errors;
  })


  const onSubmit = async (values) => {
    if ((!img || img === '') && tipo === 'P') {
      alert('Debe cargar el comprobante de pago')
      return
    }
    if (codigo.trim() === '' && tipo === 'I') {
      alert('Debe ingresar un código')
      return
    }
    if (rubro === 'Otros' && cual === '') {
      alert('Si su Rubro es Otros, por favor, detalle cual')
      return
    }
    if (rubro !== 'Otros') setCual('')
    setHabilitado(false)
    setEspera(true)

    try {
      const ape = values.apellido[0].toUpperCase() + values.apellido.slice(1);
      const nom = values.nombre[0].toUpperCase() + values.nombre.slice(1);

      if (tipo === 'P') {
        const data = new FormData()
        data.append('img', img)

        const subirImagen = await fetch(back + 'subir_imagen', {
          method: 'POST',
          body: data
        })
        const response = await subirImagen.json()

        const inscripcionData = {
          ...values,
          imagen: response.file.filename,
          apellido: ape,
          nombre: nom,
          rubro: rubro,
          cual: cual
        }

        const inscripcionResponse = await fetch(back + 'inscribir', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(inscripcionData)
        })

        const inscripcionJson = await inscripcionResponse.json()
        setRechazado(inscripcionJson.res)
        if (inscripcionJson.res)
          setQr(inscripcionJson.id)

      } else {
        const inscripcionData = {
          ...values,
          codigo: codigo,
          apellido: ape,
          nombre: nom,
          rubro: rubro,
          cual: cual
        }

        const inscripcionResponse = await fetch(back + 'inscribir', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(inscripcionData)
        })

        const inscripcionJson = await inscripcionResponse.json()
        setRechazado(inscripcionJson.res)
        if (inscripcionJson.res)
          setQr(inscripcionJson.id)
      }
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setEspera(false)
    }
  }

  const validar = () => {
    const data = { codigo: codigo }
    fetch(back + 'validar', {
      body: JSON.stringify(data),
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => response.json())
      .then(json => {
        setValido(json.success)
        if (!json.success)
          alert('El código no es válido')
      })
  }




  async function descargar() {
    try {
      const response = await fetch(`https://inscripcion.ar/servicios/back_foroeconomico/tarjetas/FEC${qr}.png`)
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'FEC' + qr + '.png'
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }, 100);

    } catch (error) {
      console.error('Error al descargar:', error);

    }
  }

  return (
    <>
      <div className="flex flex-col items-center h-full pt-2 bg-sky-50 min-h-screen">
        <div className="bg-white w-full max-w-[800px] "> {/* Ajusta el valor según necesites */}
          {/* Imagen */}
          <img
            src={Cabecera}
            className='w-full h-auto'
            alt="Imagen del evento"
          />


          {/* Título */}
          {!rechazado && (
            <div className="sm:text-lg md:text-4xl text-teal-600 bg-sky-50 py-3 text-center">
              Formulario de Inscripción
            </div>
          )}

          {/* Formulario */}
          <div className="px-2">
            {habilitado ? (
              <>
                <Formik
                  initialValues={initialValues}
                  validate={validate}
                  onSubmit={onSubmit}
                >
                  {() => (
                    <Form>
                      <div className="px-2 pt-2">
                        <label className={formato2} htmlFor="tipo">Tipo de Inscripción</label>
                        <div className="flex flex-col my-3 text-sm">
                          <label>Inscripción al Público en General (hasta el 05/05/2026):  $ 35.000.-</label>
                          <label>Inscripción al Público en General (desde el 06/05/2026):  $ 45.000.-</label>
                          <label>Inscripción al Invitado de Sponsor: (Ingresar código)</label>
                        </div>
                        <div className="flex flex-row">
                          <input type="radio" name="tipo" value='P' checked={tipo === 'P'} onChange={(e => setTipo(e.target.value))} />
                          <label className="ml-3">Público en general</label>
                        </div>
                        <div className="flex flex-row">
                          <input type="radio" name="tipo" value={'I'} checked={tipo === 'I'} onChange={(e => setTipo(e.target.value))} />
                          <label className="ml-3">Invitado de Sponsor</label>
                        </div>
                        {tipo === 'P' ?
                          ''
                          :
                          <div className="flex flex-row justify-evenly w-1/6 items-center">
                            <div className={formato1}>
                              <label className={formatoCod} htmlFor="codigo">Código</label>
                              {valido ?
                                <label className={formato2}>{codigo}</label>
                                :
                                <input
                                  className={formato3 + ' w-40'}
                                  type="text"
                                  value={codigo}
                                  onChange={e => setCodigo(e.target.value)}
                                />
                              }
                            </div>
                            {valido ?
                              <Check className="text-green-600" style={{ fontSize: 48 }} />
                              :
                              <button type="button" className="md:text-lg ml-10 p-3 rounded-xl bg-blue-200 hover:bg-blue-800 hover:text-white" onClick={validar}>Validar</button>
                            }
                          </div>
                        }
                        {valido || tipo === 'P' ? (<>
                          <div className={formato1}>
                            <label className={formato2} htmlFor="apellido">Apellido</label>
                            <Field className={formato3} type="text" name="apellido" />
                            <ErrorMessage name="apellido" component="div" className="text-red-600" />
                          </div>
                          <div className={formato1}>
                            <label className={formato2} htmlFor="nombre">Nombre</label>
                            <Field className={formato3} type="text" name="nombre" />
                            <ErrorMessage name="nombre" component="div" className="text-red-600" />
                          </div>
                          <div className={formato1}>
                            <label className={formato2} htmlFor="documento">DNI</label>
                            <Field className={formato3} type="text" name="documento" />
                            <ErrorMessage name="documento" component="div" className="text-red-600" />
                          </div>
                          <div className={formato1}>
                            <label className={formato2 + ' mb-2'} htmlFor="rubro">Rubro</label>
                            <select onChange={e => setRubro(e.target.value)} value={rubro} className='outline-0 px-2 text-sm'>
                              {rubros.map((a, index) => {
                                return <option key={index} value={a.cartel}>{a.cartel}</option>
                              })}
                            </select>
                          </div>
                          {rubro === 'Otros' ?
                            <div className={formato1}>
                              <label className={formato2} htmlFor="cual">¿Cual?</label>
                              <input className={formato3} type="text" value={cual} onChange={e => setCual(e.target.value)} />
                            </div>
                            : ''}
                          <div className={formato1}>
                            <label className={formato2} htmlFor="empresa">Empresa</label>
                            <Field className={formato3} type="text" name="empresa" />
                            <ErrorMessage name="empresa" component="div" className="text-red-600" />
                          </div>
                          <div className={formato1}>
                            <label className={formato2} htmlFor="cargo">Cargo</label>
                            <Field className={formato3} type="text" name="cargo" />
                            <ErrorMessage name="cargo" component="div" className="text-red-600" />
                          </div>
                          <div className={formato1}>
                            <label className={formato2} htmlFor="email">Email</label>
                            <Field className={formato_mail} type="text" name="email" />
                            <ErrorMessage name="email" component="div" className="text-red-600" />
                          </div>
                          <div className={formato1}>
                            <label className={formato2} htmlFor="telefono">Celular</label>
                            <Field className={formato3} type="text" name="telefono" />
                            <ErrorMessage name="telefono" component="div" className="text-red-600" />
                          </div>

                          {tipo === 'P' ? (<>
                            <div className="flex flex-col text-sm">
                              <label className='font-semibold underline'>Datos para Transferencia:</label>
                              <label>Titular: Omar Abdala</label>
                              <label>Cuit: 20-32693967-7</label>
                              <label>CVU: 0000003100073195236132</label>
                              <label>Alias: omar1986abdala</label>
                            </div>
                            <div className="flex flex-row justify-between w-full items-center">
                              <div className={formato1}>
                                <label className={formato2} htmlFor="img">Comprobante de pago</label>
                                <Field type="file" name="imagen" accept="image/jpeg, image/png, application/pdf" onChange={(e) => setImg(e.target.files[0])} />
                              </div>
                              {img !== null && img !== '' ?
                                <img src={URL.createObjectURL(img)} alt="Imagen seleccionada" width="100" />
                                :
                                ''
                              }
                            </div>
                          </>)
                            : ''}

                          <div className="flex flex-col  items-center mb-5">
                            <button type="submit" className="md:text-2xl mt-10 p-5 rounded-full bg-blue-200 hover:bg-blue-800 hover:text-white" disabled={!habilitado}>
                              INSCRIBIRME
                            </button>
                          </div>
                        </>) : ''}
                      </div>
                    </Form>
                  )}
                </Formik>
                <footer className='flex flex-row justify-between items-center w-full bg-zinc-800 text-white font-semibold mb-2 py-2'>
                  <div className='flex flex-col justify-between items-center w-2/3'>
                    <div className='sm:text-sm md:text-base text-center hover:text-red-500'><a href='https://www.nannini.ar' target='_blanck'>© Fabian Nannini<br />Acreditaciones</a></div>
                    <div className='flex flex-row justify-center items-center sm:text-sm md:text-lg '>
                      <img src='./instagram.png' alt='logo Ig' className='w-4 mr-2' />
                      <a className='hover:text-red-500 text-sm' href='https://instagram.com/nanniniacreditaciones' target='_blanck'>@nanniniacreditaciones</a>
                    </div>
                  </div>
                  <div className='flex flex-row justify-right items-center sm:text-xs  w-1/3'>
                    <label>Powered by AGS</label>
                  </div>
                </footer>
              </>
            ) : ''}

            {!habilitado && espera && !rechazado && (
              <div className="flex flex-col bg-white items-center mt-5 sm:text-sm md:text-lg px-2">
                <div className="flex flex-col px-2 items-center w-full">
                  <p className="text-center">
                    Aguarde unos instantes
                  </p>
                </div>
              </div>
            )}

            {!habilitado && !espera && rechazado &&
              <div className="flex flex-col bg-white items-center mt-5 sm:text-sm md:text-lg px-2">
                <div className="flex flex-col px-2 items-center w-full">
                  <p className="text-center">Tu inscripción al <span className='font-semibold'>Foro Económico Casilda</span><br />
                    fue registrado correctamente.<br />
                    Descargá este QR y guárdalo en tu celular, para poder ingresar al evento.</p>
                  <div className="flex items-center justify-around ">
                    <img src={'https://inscripcion.ar/servicios/back_foroeconomico/QRs/FEC' + qr + '.jpg'} alt="QR" className="w-1/3 border-2 border-black my-3 justify-center" />
                    <div className="flex flex-col items-center">
                      <label className="text-center font-semibold my-2 text-lg">{'FEC' + qr.toString().padStart(4, '0')}</label>
                      <button
                        className="text-white bg-blue-600 hover:bg-blue-800 rounded-lg p-2 m-5"
                        onClick={() => descargar()}
                      >
                        Descargar QR
                      </button>
                    </div>
                  </div>
                  <p className="text-center mb-5">Este mismo código también lo vas a recibir al correo que te inscribiste.<br />Si no lo ves en tu bandeja de entrada, verifica SPAM y/o correo no deseado.</p>
                </div>
              </div>
            }

            {!habilitado && !espera && !rechazado &&
              <label className="text-center font-semibold my-5 text-lg">¡Error! documento ya registrado </label>
            }
          </div>
        </div>
      </div>
    </>
  )
}
